const translation = {
  // Nav
  nav_home: "Início",
  nav_back_home: "Voltar ao Início",
  nav_about: "Sobre",
  nav_menu: "Menu",
  nav_gallery: "Galeria",
  nav_testimonials: "Testemunhos",
  nav_contact: "Contacto",
  nav_reserve: "Reservar Mesa",

  // Hero
  hero_since: "Desde 1994",
  hero_title_1: "Cantinho",
  hero_title_2: "do Cais",
  hero_subtitle: "Cozinha açoriana de sabores autênticos e um ambiente familiar onde se sente em casa.",
  hero_cta_menu: "Ver Menu",
  hero_cta_reserve: "Reservar Mesa",
  hero_scroll: "Explorar",

  // About
  about_label: "A Nossa História",
  about_title_1: "Tradição e Paixão",
  about_title_2: "em Cada Prato",
  about_highlight: "É obrigatório provar a deliciosa sopa de peixe.",
  about_p1: "O Cantinho do Cais nasceu da profunda ligação ao mar e à alma piscatória açoriana. Originalmente fundado no Porto Formoso, junto ao antigo cais onde os barcos tradicionais atracavam, o restaurante ganhou o seu nome pela proximidade à pequena lota local — o sítio onde o peixe saltava diretamente das redes para as mãos da nossa cozinha.",
  about_p2: "O tempo trouxe novos desafios e o restaurante acabou por renascer em São Brás. Embora as águas do cais tenham ficado fisicamente para trás, a essência e o nome permaneceram intactos, carregando consigo as memórias, o respeito pelo mar e a tradição construída ao longo de décadas.",
  about_p3: "Hoje, continuamos a ser um espaço de gerência orgulhosamente familiar, onde a simplicidade, a hospitalidade e os sabores autênticos da ilha de São Miguel se sentam à mesa. Diariamente, o Sr. Jorge mantém vivo o espírito da compra de peixe fresco, visitando o mercado para selecionar, a dedo, os melhores exemplares que chegam à nossa cozinha.",
  about_p4: "Especialistas em peixe e cozinha regional, honramos o paladar açoriano através da nossa famosa Sopa de Peixe, do tradicional Molho de Peixe e de iguarias preparadas com espécies da nossa costa — como o Cântaro, a Boca Negra, a Abrótea, o Alfonsim, o Atum, o Polvo, entre outros peixes e mariscos selecionados diariamente. Seja em grelhados que respeitam a frescura do mar ou em pratos mais elaborados da cozinha açoriana, cada receita celebra o melhor da ilha. Entre segredos de sempre e sobremesas caseiras, abrimos as nossas portas para que cada cliente se sinta, verdadeiramente, em casa.",
  about_cta: "Conheça a Nossa Equipa",
  about_stat_1_num: "30+",
  about_stat_1_label: "Anos de Experiência",
  about_stat_2_num: "90%+",
  about_stat_2_label: "Ingredientes Locais",
  about_stat_3_num: "4.5★",
  about_stat_3_label: "Avaliação Média",
  about_quote_text: "Uma experiência gastronómica memorável.",

  // Menu Categories & Prices
  menu_label: "Menu",
  menu_title_1: "Descubra os Nossos",
  menu_title_2: "Sabores Únicos",
  menu_subtitle: "Uma seleção cuidada de pratos que celebram a riqueza dos Açores",
  menu_from: "A partir de",
  menu_view: "Ver Pratos",
  menu_cat_starters: "Entradas",
  menu_cat_starters_desc: "Lapas, mexilhões, camarão, sopa de peixe e petiscos da ilha para começar com sabor.",
  menu_cat_fish: "Pratos de Peixe",
  menu_cat_fish_desc: "Molho de Peixe, Polvo, Boca Negra, Abrótea, Alfonsim e muito mais, na grelha ou em pratos elaborados.",
  menu_cat_meat: "Pratos de Carne",
  menu_cat_meat_desc: "Assaduras, bife de novilho e outros pratos de carne confecionados com os melhores ingredientes açorianos.",
  menu_cat_vegetarian: "Pratos Vegetarianos",
  menu_cat_vegetarian_desc: "Saladas frescas, legumes da época e pratos vegetarianos confecionados com produtos locais dos Açores.",
  menu_cat_kids: "Menu Infantil",
  menu_cat_kids_desc: "Refeições equilibradas e saborosas, pensadas especialmente para os mais pequenos.",
  menu_cat_desserts: "Sobremesas",
  menu_cat_desserts_desc: "Queijadas, frutas tradicionais e sobremesas caseiras para terminar em beleza.",
  menu_price_starters: "€3,50",
  menu_price_fish: "€10,00",
  menu_price_meat: "€10,00",
  menu_price_vegetarian: "€7,50",
  menu_price_kids: "€6,50",
  menu_price_desserts: "€1,20",
  
  // Preçário e Bebidas
  menu_suggestion_question: "Gostou das nossas sugestões?",
  menu_full_price_list: "Ver Preçário Completo e Carta de Vinhos",
  menu_section_food: "Comida",
  menu_section_drinks: "Bebidas",
  menu_cat_vines: "Vinhos",
  menu_cat_reds: "Tintos",
  menu_cat_whites: "Brancos",
  menu_cat_greens_alvarinhos: "Verdes e Alvarinhos",
  menu_cat_roses: "Rosés",
  menu_cat_sparkling: "Espumantes",
  menu_cat_brewery: "Cervejaria",
  menu_cat_águas: "Águas",
  menu_cat_sumos: "Sumos",
  menu_cat_licores: "Licores",
  menu_cat_aguardentes: "Aguardentes",
  menu_cat_brandys: "Brandys",
  menu_cat_whiskys: "Whiskys",

  // Cervejaria (Em português mantém exatamente o nome original limpo)
  cerveja_fino: "Fino",
  cerveja_tulipa: "Tulipa",
  cerveja_caneca: "Caneca",
  cerveja_garrafa: "Garrafa",
  cerveja_panache: "Panaché",
  cerveja_caldeado_cerveja: "Caldeado com cerveja",
  cerveja_caldeado_vinho: "Caldeado com vinho",

  // Águas (Em português mantém o nome original limpo)
  agua_sem_gas: "Água sem gás",
  agua_com_gas: "Água com gás",
  agua_tonica: "Água Tónica",

  // Riscos / Shots (Em português mantém o nome original limpo)
  bebida_risco_licor: "\"Risco\" de Licor",
  bebida_risco_brandy: "\"Risco\" de Brandy",
  bebida_risco_whisky: "\"Risco\" Whisky Novo",

  // Regiões de Vinhos exatas
  regiao_alentejo: "Alentejo",
  regiao_douro: "Douro",
  regiao_dão: "Dão",
  regiao_outras_regiões: "Outras Regiões",

  // Modals
  modal_close: "Fechar",
  modal_availability: "Disponibilidade sujeita à época e stock diário",
  modal_starters_title: "As Nossas Entradas",
  modal_fish_title: "Os Nossos Pratos de Peixe",
  modal_meat_title: "Os Nossos Pratos de Carne",
  modal_vegetarian_title: "Os Nossos Pratos Vegetarianos",
  modal_kids_title: "O Nosso Menu Infantil",
  modal_desserts_title: "As Nossas Sobremesas",

  // All Dishes (Unified list - No duplicates)
  dish_salada_queijo_fresco: "Salada com Queijo Fresco",
  dish_omeletes: "Omeletes",
  dish_salada_feijao: "Salada de Feijão",
  dish_filetes_fritos: "Filetes Fritos",
  dish_lombinhos: "Lombinhos",
  dish_hamburguer_prato: "Hambúrguer no Prato",
  dish_note_sob_consulta: "(sob consulta)",
  dish_note_por_encomenda: "(por encomenda)",
  dish_camarao: "Camarão",
  dish_favas_guisadas: "Favas Guisadas",
  dish_iscas_atum: "Iscas de Atum",
  dish_lapas_grelhadas: "Lapas Grelhadas",
  dish_mexilhoes_grelhados: "Mexilhão Grelhado",
  dish_queijo_curado: "Queijo Curado",
  dish_queijo_fresco: "Queijo Fresco",
  dish_sopa_peixe: "Sopa de Peixe",
  dish_atum: "Atum",
  dish_bacalhau: "Bacalhau",
  dish_chicharros_fritos: "Chicharros Fritos",
  dish_lulas_grelhadas: "Lulas Grelhadas",
  dish_peixe_grelhado: "Peixe Grelhado",
  dish_polvo_assado: "Polvo Assado",
  dish_polvo_guisado: "Polvo Guisado",
  dish_molho_peixe: "Molho de Peixe",
  dish_assaduras: "Assaduras",
  dish_bifanas: "Bifanas",
  dish_bife_novilho: "Bife de Novilho",
  dish_peito_frango: "Peito de Frango",
  dish_ananas: "Ananás",
  dish_gelados: "Gelados",
  dish_queijadas: "Queijadas",

  // Gallery
  gallery_label: "Galeria",
  gallery_title: "Momentos Inesquecíveis",
  gallery_subtitle: "Uma viagem visual pela nossa cozinha, ambiente e sabores",

  // Testimonials
  testimonials_label: "Testemunhos",
  testimonials_title_1: "O Que Dizem os",
  testimonials_title_2: "Nossos Clientes",
  testimonials_prev: "Anterior",
  testimonials_next: "Próximo",

  // Reservations & Contact
  reservations_label: "Reservas",
  reservations_title: "Reserve a Sua Mesa",
  reservations_subtitle: "Escolha o dia e entre em contacto connosco",
  reservations_prev_month: "Mês anterior",
  reservations_next_month: "Próximo mês",
  reservations_modal_title: "Reserva para",
  reservations_modal_subtitle: "Como prefere fazer a sua reserva?",
  reservations_phone_title: "Reservar por Telefone",
  reservations_phone_desc: "Durante a chamada, indique o dia, hora pretendida, nome da reserva, número de pessoas e contacto.",
  reservations_phone_cta: "Ligar Agora",
  reservations_email_title: "Pedir Reserva por Email",
  reservations_email_desc: "Enviaremos um email pré-preenchido com o dia selecionado. Complete os restantes detalhes.",
  reservations_email_cta: "Enviar Email",
  reservations_close: "Fechar",
  reservations_email_subject: "Pedido de Reserva - Cantinho do Cais",
  reservations_email_body: "Olá,\n\nGostaria de fazer uma reserva com os seguintes detalhes:\n\nDia: {date}\nHora: [preencher]\nNome da reserva: [preencher]\nNúmero de pessoas: [preencher]\nContacto: [preencher]\n\nAguardo confirmação.\n\nObrigado.\n\n---\n⚠️ Nota: Se esta reserva for feita com menos de 12 horas de antecedência, por favor ligue para o restaurante (296 442 631) para confirmar a disponibilidade.",
  contact_label: "Contacto",
  contact_title: "Venha Visitar-nos",
  contact_subtitle: "Estamos à sua espera em São Brás, Açores",
  contact_address_label: "Morada",
  contact_address: "Rua do Ramal 1, 9625-510 São Brás",
  contact_phone_label: "Telefone",
  contact_phone: "296 442 631",
  contact_hours_label: "Horário",
  contact_hours_1: "Segunda, Terça, Quinta a Domingo: 12h00 – 22h00",
  contact_hours_2: "Quarta-feira: Encerrado",
  contact_form_title: "Envie-nos uma Mensagem",
  contact_form_name: "Nome",
  contact_form_email: "Email",
  contact_form_message: "Mensagem",
  contact_form_submit: "Enviar Mensagem",
  contact_form_success: "Message sent successfully! Entraremos em contacto brevemente.",
  contact_form_error: "Ocorreu um erro. Por favor tente novamente.",
  contact_call_cta: "Ligar Agora",

  // Footer
  footer_tagline: "Cozinha açoriana de sabores autênticos em São Brás",
  footer_nav_title: "Acesso Rápido",
  footer_info_title: "Informações",
  footer_legal_title: "Legal",
  footer_privacy: "Política de Privacidade",
  footer_terms: "Termos de Uso",
  footer_cookies: "Política de Cookies",
  footer_copyright: "© 2026 Cantinho do Cais. Todos os direitos reservados.",
  footer_developed_by: "Desenvolvido por Ponto Zero Apps",
  footer_newsletter_title: "Novidades e Promoções",
  footer_newsletter_desc: "Receba as nossas novidades e promoções especiais",
  footer_newsletter_placeholder: "O seu email",
  footer_newsletter_cta: "Subscrever",
  footer_made_with: "Feito com",
  footer_in: "nos Açores",
  footer_complaints: "Livro de Reclamações",

  // --- PÁGINAS LEGAIS ---

  // Cookies
  cookies_title: "Política de Cookies",
  cookies_intro_1: "O website do ",
  cookies_intro_2: " utiliza cookies para garantir que lhe proporcionamos a melhor experiência de navegação.",
  cookies_h1: "1. O que são Cookies?",
  cookies_p1: "Cookies são pequenos ficheiros de texto guardados no seu computador ou dispositivo móvel através do navegador de internet (browser). Estes ficheiros permitem que o website se \"lembre\" das suas ações e preferências (como o idioma escolhido) durante um determinado período de tempo.",
  cookies_h2: "2. Que Cookies utilizamos?",
  cookies_p2_1: "O nosso website utiliza apenas ",
  cookies_p2_2: " e ",
  cookies_p2_strong1: "Cookies Estritamente Necessários",
  cookies_p2_strong2: "Cookies Funcionais",
  cookies_li1_strong: "Cookies de Idioma:",
  cookies_li1_text: " Utilizados para memorizar o idioma (Português, Inglês ou Alemão) que escolheu para navegar no site, para que não tenha de o selecionar novamente sempre que visita uma nova página.",
  cookies_li2_strong: "Cookies de Performance/Análise:",
  cookies_li2_text: " Utilizamos ferramentas de análise anónimas que não recolhem dados pessoais (não rastreiam IP nem identificam o utilizador), servindo apenas para contagem de visitas e melhoria do desempenho do site.",
  cookies_p3: "Não utilizamos cookies de publicidade direcionada ou marketing de terceiros.",
  cookies_h3: "3. Como Gerir os Cookies?",
  cookies_p4: "Pode bloquear ou apagar os cookies nas definições do seu navegador a qualquer momento. No entanto, ao desativar os cookies, algumas funcionalidades do website (como a memorização do idioma) poderão deixar de funcionar corretamente. Para mais informações sobre como gerir cookies, consulte a secção de \"Ajuda\" do seu navegador.",

  // Privacidade
  privacy_title: "Política de Privacidade",
  privacy_intro_1: "O ",
  privacy_intro_2: " respeita a privacidade de todos os utilizadores do seu website e compromete-se a proteger as informações pessoais que cada utilizador decidir partilhar.",
  privacy_h1: "1. Recolha de Dados",
  privacy_p1: "Ao navegar no nosso website, não recolhemos informações pessoais automaticamente. Os únicos dados pessoais aos quais temos acesso são aqueles que nos fornece voluntariamente ao entrar em contacto connosco via telefone (como nome, número de telefone e detalhes de reserva).",
  privacy_h2: "2. Utilização dos Dados",
  privacy_p2: "Os dados fornecidos serão utilizados exclusivamente para:",
  privacy_li1: "Responder a pedidos de informação ou contacto.",
  privacy_li2: "Processar e gerir pedidos de reserva de mesa.",
  privacy_li3: "Melhorar a experiência do utilizador no nosso espaço.",
  privacy_h3: "3. Partilha de Dados",
  privacy_p3: "O Cantinho do Cais não vende, aluga ou partilha os seus dados pessoais com terceiros, exceto quando estritamente necessário para o cumprimento de obrigações legais.",
  privacy_h4: "4. Retenção de Dados",
  privacy_p4: "Os seus dados serão guardados apenas pelo tempo necessário para a finalidade para a qual foram recolhidos (por exemplo, até à data da sua reserva ou conclusão do seu pedido de contacto).",
  privacy_h5: "5. Os Seus Direitos",
  privacy_p5: "Ao abrigo do RGPD, tem o direito de solicitar o acesso, retificação ou eliminação dos seus dados pessoais. Para exercer estes direitos, por favor contacte-nos através do telefone 296 442 631 ou presencialmente na nossa morada: Rua do Ramal 1, 9625-510 São Brás, Açores.",
  privacy_h6: "6. Alterações a esta Política",
  privacy_p6: "Reservamo-nos o direito de atualizar esta Política de Privacidade sempre que necessário. Recomendamos a consulta periódica desta página.",

  // Termos
  terms_title: "Termos de Uso",
  terms_intro_1: "Bem-vindo ao website do ",
  terms_intro_2: ". Ao aceder e utilizar este website, concorda em cumprir os seguintes termos e condições.",
  terms_h1: "1. Propósito do Website",
  terms_p1: "Este website tem um caráter estritamente informativo, destinando-se a apresentar o nosso espaço, menu, horários, localização e métodos de contacto/reserva.",
  terms_h2: "2. Informações do Menu e Preços",
  terms_p2: "Fazemos todos os esforços para garantir que as informações apresentadas no website estão atualizadas. No entanto, os preços, pratos e disponibilidade dos produtos (especialmente peixe fresco e marisco) estão sujeitos a alterações sem aviso prévio, dependendo do mercado diário e da época. As imagens apresentadas na galeria são meramente ilustrativas.",
  terms_h3: "3. Propriedade Intelectual",
  terms_p3: "Todo o conteúdo presente neste website, incluindo textos, logótipos, gráficos e imagens, é propriedade do Cantinho do Cais ou está licenciado para nosso uso, e encontra-se protegido por leis de direitos de autor. É estritamente proibida a reprodução, modificação ou distribuição de qualquer conteúdo sem autorização prévia.",
  terms_h4: "4. Reservas",
  terms_p4: "Todas as reservas de mesa devem ser efetuadas exclusivamente por contacto telefónico direto para o restaurante, estando sujeitas a confirmação de disponibilidade.",
  terms_h5: "5. Limitação de Responsabilidade",
  terms_p5: "O Cantinho do Cais não se responsabiliza por eventuais danos ou problemas técnicos resultantes da utilização deste website ou de links externos para outras plataformas (como o Livro de Reclamações Eletrónico).",
  terms_h6: "6. Contactos",
  terms_p6: "Para qualquer dúvida sobre estes Termos de Uso, contacte-nos através do telefone 296 442 631 ou visite-nos na Rua do Ramal 1, 9625-510 São Brás."
};

export default translation;